import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay, take } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Environment, EnvironmentService } from '@galaxy/core';

export interface TaxonomyOption {
  name: string; // The name of the taxonomy option
  fullName: string; // The full name of the taxonomy option, including parent taxonomies
  id: string; // The id that represents this taxonomy option
}

@Injectable({ providedIn: 'root' })
class CategoriesApiService {
  apiOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    withCredentials: true,
  };

  private host: string;
  private lookupUrl = `${this.taxonomyServiceHost}/_ajax/v1/list-taxonomies/`;

  constructor(public http: HttpClient, private environmentService: EnvironmentService) {}

  private get taxonomyServiceHost(): string {
    if (this.host) {
      return this.host;
    }
    switch (this.environmentService.getEnvironment()) {
      case Environment.LOCAL:
        this.host = '';
        break;
      case Environment.DEMO:
        this.host = 'https://partner-central-demo.appspot.com';
        break;
      case Environment.PROD:
        this.host = 'https://partners.vendasta.com';
        break;
    }
    return this.host;
  }

  public getTaxonomyIds(): Observable<TaxonomyOption[]> {
    return this.http.get(this.lookupUrl, this.apiOptions).pipe(
      catchError((err) => {
        console.error(err);
        console.error('Retrieving taxonomy ids does not work from the shell client');
        return of({ data: [] });
      }),
      map((resp: any) => resp?.data),
    );
  }
}
@Injectable({ providedIn: 'root' })
export class CategoriesService {
  categories$ = this.taxonomyService.getTaxonomyIds().pipe(take(1), shareReplay({ bufferSize: 1, refCount: true }));

  constructor(private readonly taxonomyService: CategoriesApiService) {}

  getNamesFromCategoryIDs(ids: string[]): Observable<string[]> {
    return this.categories$.pipe(
      map((categories) => categories.filter((c) => (ids || []).includes(c.id)).map((c) => c.name)),
    );
  }
}
